export const getDeviceState = async () => {
  const devices = await navigator.mediaDevices.enumerateDevices();
  const hasCamera = !!devices.find((d) => d.kind === 'videoinput');
  const hasMicrophone = !!devices.find((d) => d.kind === 'audioinput');
  const hasCameraPermission = !!devices.find(
    (d) => d.kind === 'videoinput' && d.label !== ''
  );
  const hasMicrophonePermission = !!devices.find(
    (d) => d.kind === 'audioinput' && d.label !== ''
  );
  //  console.log({ devices, hasCamera });

  return { hasCamera, hasMicrophone, hasCameraPermission, hasMicrophonePermission };
};

export const handleConnectionStateChange = (peer) => {
  console.log('connection state change');
  
  switch (peer.connectionState) {
    case 'new':
    case 'checking':
      console.log('Connecting...');
      break;
    case 'connected':
      console.log('Online...');
      break;
    case 'disconnected':
      console.log('Disconnecting...');
      break;
    case 'closed':
      console.log('Offline...');
      break;
    case 'failed':
      console.log('Error...');
      break;
    default:
      console.log('Unknown...');
      break;
  }
};

export const peerConnectionConfig = {
  iceServers: [
    { urls: 'stun:stun.l.google.com:19302' },
    { urls: 'stun:stun1.l.google.com:19302' },
    { urls: 'stun:stun2.l.google.com:19302' },
    { urls: 'stun:stun3.l.google.com:19302' },
    { urls: 'stun:stun4.l.google.com:19302' },
  ],
};